import { CellProps, ChevronRightIcon, DivStyledAsLink, Flex } from "@shared/primitive-components"
import { navigationWithAltClick } from "@shared/utils/helpers/navigationWithAltClick"
import { tableCellStyles as styles } from "../../../styles"

type Props = {
  baseUrl?: string
  dataTestId?: string
}

export const ChevronLinkCell = <T extends Record<string, unknown>>({ dataTestId, baseUrl }: Props) =>
  function ({ value }: CellProps<string, T>) {
    return (
      <DivStyledAsLink onClick={baseUrl ? (e) => navigationWithAltClick(value, e, baseUrl) : undefined}>
        <Flex alignItems="center" css={styles.chevronLinkStyle} data-testid={dataTestId}>
          <ChevronRightIcon />
        </Flex>
      </DivStyledAsLink>
    )
  }
